import { VStack } from '@chakra-ui/react';
import { EmailBlockSection } from '../../../components/EmailBlockSection';
import type { InterviewCommPanelBaseProps } from '../../../components/panelProps.types';
import { TemplatedEmail } from '../../../components/TemplatedEmail';
import { IcsAttachmentCheckbox } from '../../../components/IcsAttachmentCheckbox';

export const InterviewerCommunicationPanel = ({
  state,
  dispatch,
  fieldErrors,
  interviewerCalendarTemplateOptions,
  interviewerEmailTemplateOptions,
  fromOptions,
  ccBccOptions,
  interviewerCalendarVariables,
  interviewerEmailVariables,
  uploadInlineImage,
}: InterviewCommPanelBaseProps) => (
  <VStack align="stretch" spacing="4" w="100%">
    <EmailBlockSection
      title="Interviewer's calendar invite"
      sectionId="interview-comm-interviewer-calendar"
    >
      <TemplatedEmail
        className="w-full"
        showFrom={false}
        showTo={false}
        showSubject={false}
        enableCcBcc={false}
        showTemplate
        showEditor
        editorVariant="calendarInvite"
        variables={interviewerCalendarVariables}
        templateOptions={interviewerCalendarTemplateOptions}
        applyTemplateBodyToEditor
        value={state.interviewerCalendar}
        onChange={(value) =>
          dispatch({ type: 'SET_INTERVIEWER_CALENDAR', payload: value })
        }
        errors={fieldErrors.interviewerCalendar}
        placeholders={{ template: 'Select a template' }}
      />
    </EmailBlockSection>

    <EmailBlockSection
      title="Interviewer's email"
      sectionId="interview-comm-interviewer-email"
      showSwitch
      switchChecked={state.interviewerEmailEnabled}
      onSwitchChange={(checked) =>
        dispatch({ type: 'SET_INTERVIEWER_EMAIL_ENABLED', payload: checked })
      }
    >
      {state.interviewerEmailEnabled ? (
        <>
          <TemplatedEmail
            className="w-full"
            showFrom
            showTo={false}
            showSubject
            enableCcBcc
            showTemplate
            showEditor
            editorVariant="richEmail"
            variables={interviewerEmailVariables}
            attachments={state.interviewerEmailAttachments}
            onAttachmentsChange={(items) =>
              dispatch({
                type: 'SET_INTERVIEWER_EMAIL_ATTACHMENTS',
                payload: items,
              })
            }
            templateOptions={interviewerEmailTemplateOptions}
            fromOptions={fromOptions}
            ccBccOptions={ccBccOptions}
            applyTemplateBodyToEditor
            value={state.interviewerEmail}
            onChange={(value) =>
              dispatch({ type: 'SET_INTERVIEWER_EMAIL', payload: value })
            }
            errors={fieldErrors.interviewerEmail}
            placeholders={{
              from: 'Select from',
              subject: 'Additional email for context',
              template: 'Select a template',
            }}
            uploadInlineImage={uploadInlineImage}
          />
          <IcsAttachmentCheckbox
            checked={state.interviewerIcsEnabled}
            onChange={(v) =>
              dispatch({ type: 'SET_INTERVIEWER_ICS_ENABLED', payload: v })
            }
          />
        </>
      ) : null}
    </EmailBlockSection>
  </VStack>
);
